import { render, staticRenderFns } from "./PackingCode.vue?vue&type=template&id=be0b0b8e&scoped=true"
import script from "./PackingCode.vue?vue&type=script&lang=js"
export * from "./PackingCode.vue?vue&type=script&lang=js"
import style0 from "./PackingCode.vue?vue&type=style&index=0&id=be0b0b8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0b0b8e",
  null
  
)

export default component.exports